define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/core/ExtendedPath",
	"csi/def/AddPath",
	"csi/reflection",
	"csi/resolver",
	"./_CalendarHierarchyActivities"
], function(declare, lang, _, ExtendedPath, AddPath, reflection, resolver, _CalendarHierarchyActivities) {

	return declare(_CalendarHierarchyActivities, {
	});
});